// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1ohcv","consentsList":"PatientConsents_consentsList__1c1q9","consentsListEmpty":"PatientConsents_consentsListEmpty__3CUuK"};